import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "MainPagePc"
}
const _hoisted_2 = { class: "tableborder" }
const _hoisted_3 = { class: "booking-table" }
const _hoisted_4 = { class: "table-row" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { style: {"display":"inline-flex","align-items":"center","gap":"40px"} }
const _hoisted_7 = {
  key: 0,
  style: {"display":"inline-flex","align-items":"center","gap":"8px"}
}
const _hoisted_8 = {
  key: 1,
  style: {"display":"inline-flex","align-items":"center","gap":"8px"}
}
const _hoisted_9 = { style: {"display":"inline-flex","align-items":"center","gap":"8px"} }
const _hoisted_10 = { style: {"display":"inline-flex","gap":"16px","align-items":"center"} }
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { style: {"display":"inline-flex","gap":"8px","width":"fit-content"} }
const _hoisted_13 = {
  key: 1,
  class: "MainPageMobile"
}
const _hoisted_14 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"} }
const _hoisted_15 = { style: {"padding-bottom":"140px","overflow-y":"scroll","display":"flex","flex-direction":"column"} }
const _hoisted_16 = { class: "reservation-box" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { style: {"margin-left":"16px"} }
const _hoisted_19 = { class: "header-button-wrapper" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { style: {"margin-left":"16px"} }
const _hoisted_22 = { class: "header-button-wrapper" }
const _hoisted_23 = {
  key: 2,
  class: "reservation-info"
}
const _hoisted_24 = { class: "res-info" }
const _hoisted_25 = {
  key: 0,
  style: {"display":"inline-flex","align-items":"center","gap":"8px","margin-bottom":"4px"}
}
const _hoisted_26 = {
  key: 1,
  style: {"display":"inline-flex","align-items":"center","gap":"8px","margin-bottom":"4px"}
}
const _hoisted_27 = { style: {"display":"inline-flex","align-items":"center","gap":"8px","margin-bottom":"4px"} }
const _hoisted_28 = { style: {"display":"inline-flex","gap":"8px","width":"90%","margin-bottom":"16px"} }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatingBottomBar = _resolveComponent("FloatingBottomBar")!
  const _component_label_bar = _resolveComponent("label-bar")!
  const _component_input_field_with_message = _resolveComponent("input-field-with-message")!
  const _component_country_code_picker = _resolveComponent("country-code-picker")!
  const _component_apply_phone_code_box = _resolveComponent("apply-phone-code-box")!
  const _component_send_updates_box = _resolveComponent("send-updates-box")!
  const _component_toaster = _resolveComponent("toaster")!
  const _component_phone_code_picker = _resolveComponent("phone-code-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isMobile == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[21] || (_cache[21] = _createElementVNode("h3", { style: {"margin-top":"29px"} }, "Reservation update", -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
          _cache[22] || (_cache[22] = _createElementVNode("div", { style: {"width":"100%","height":"1px","background":"rgba(34, 34, 34, 0.1)","margin-top":"16px","margin-bottom":"40px"} }, null, -1)),
          _createVNode(_component_FloatingBottomBar, {
            headerText: _ctx.isReservationDone() + ' out of ' + _ctx.JourneyList.length + ' updated',
            bodyText: _ctx.isReservationDone() !== _ctx.JourneyList.length ? 'Update the remaining reservations' : 'Confirm & send updates',
            bodyTextRed: _ctx.confirmNotReady && _ctx.isReservationDone() !== _ctx.JourneyList.length,
            active: _ctx.isReservationDone() == _ctx.JourneyList.length,
            isMobile: false,
            onUpdateConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmPressed())),
            onUpdateConfirmNotReady: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmNotReadyPressed()))
          }, null, 8, ["headerText", "bodyText", "bodyTextRed", "active"]),
          _createElementVNode("div", _hoisted_2, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start","gap":"8px","width":"1280px","margin-bottom":"40px"} }, [
              _createElementVNode("h5", null, "Reservations list"),
              _createElementVNode("p", { style: {"width":"400px"} }, "Fill out the information for each reservation, and make your upcoming stay as smooth as possible.")
            ], -1)),
            _createElementVNode("table", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.JourneyList, (journey, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle({ zIndex: _ctx.showCodePicker[index] ? '5' : '1' })
                }, [
                  _createElementVNode("tr", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h1", null, "Reservation " + _toDisplayString(index + 1), 1),
                        (!_ctx.GroupBookingList[0].HideGuestRoom)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _cache[14] || (_cache[14] = _createElementVNode("img", {
                                width: "18",
                                height: "18",
                                src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/RoomFeatures/double_bed.svg"
                              }, null, -1)),
                              _createElementVNode("p", null, _toDisplayString(_ctx.findRoomType(journey.RoomType)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.GroupBookingList[0].HideNumberOfGuest)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _cache[15] || (_cache[15] = _createElementVNode("img", {
                                width: "18",
                                height: "18",
                                src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/person.svg"
                              }, null, -1)),
                              _createElementVNode("p", null, _toDisplayString(journey.NumberOfGuest), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[16] || (_cache[16] = _createElementVNode("img", {
                            width: "18",
                            height: "18",
                            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock.svg"
                          }, null, -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(journey.StartDate)), 1),
                          _cache[17] || (_cache[17] = _createElementVNode("img", {
                            width: "14",
                            height: "14",
                            style: {"margin":"0 8px"},
                            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/arrow_1_5px/right.png"
                          }, null, -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(journey.EndDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.reservationDone(journey))
                          ? (_openBlock(), _createBlock(_component_label_bar, {
                              key: 0,
                              type: 'succes',
                              text: 'Filled out'
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"height":"1px","width":"96.25%","background":"#dfdfdf"} }, null, -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_input_field_with_message, {
                        label: 'First name',
                        inputValue: journey.FirstName,
                        widthProcent: '22.8%',
                        isRequired: _ctx.GroupBookingList[0].FirstNameRequired,
                        emailDuplicate: false,
                        phoneDuplicate: false,
                        showError: _ctx.redBorder(journey.FirstName, index, 'FirstName'),
                        onValue: ($event: any) => (_ctx.handleInputChange(journey, 'FirstName', $event))
                      }, null, 8, ["inputValue", "isRequired", "showError", "onValue"]),
                      _createVNode(_component_input_field_with_message, {
                        label: 'Last name',
                        inputValue: journey.LastName,
                        widthProcent: '22.8%',
                        isRequired: _ctx.GroupBookingList[0].LastNameRequired,
                        emailDuplicate: false,
                        phoneDuplicate: false,
                        showError: _ctx.redBorder(journey.LastName, index, 'LastName'),
                        onValue: ($event: any) => (_ctx.handleInputChange(journey, 'LastName', $event))
                      }, null, 8, ["inputValue", "isRequired", "showError", "onValue"]),
                      _createVNode(_component_input_field_with_message, {
                        label: 'Email',
                        inputValue: journey.Email,
                        widthProcent: '22.8%',
                        emailDuplicate: _ctx.duplicateEmail(journey.Email, index),
                        phoneDuplicate: false,
                        isRequired: _ctx.GroupBookingList[0].EmailRequired,
                        showError: _ctx.redBorder(journey.Email, index, 'Email'),
                        onValue: ($event: any) => (_ctx.handleInputChange(journey, 'Email', $event)),
                        onError: ($event: any) => (_ctx.handleError(journey, 'Email', $event))
                      }, null, 8, ["inputValue", "emailDuplicate", "isRequired", "showError", "onValue", "onError"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_country_code_picker, {
                            showError: _ctx.redBorder(_ctx.phoneCodes[index], index, 'PhoneCode'),
                            currentCode: _ctx.phoneCodes[index],
                            showAbove: _ctx.codePickerShowAbove(index),
                            country: _ctx.hotelCountry,
                            isMobile: false,
                            onOpenCurrent: ($event: any) => (_ctx.showCurrentCodePicker(index)),
                            onDefaultCode: ($event: any) => (_ctx.onDefaultCode(index, $event)),
                            onUpdateCode: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdateCode($event))),
                            onCloseCodePicker: ($event: any) => (_ctx.closeCodePicker(index))
                          }, null, 8, ["showError", "currentCode", "showAbove", "country", "onOpenCurrent", "onDefaultCode", "onCloseCodePicker"])
                        ]),
                        _createVNode(_component_input_field_with_message, {
                          label: 'Phone number',
                          inputValue: _ctx.phonenumbers[index],
                          widthProcent: '100%',
                          isRequired: _ctx.GroupBookingList[0].PhoneNumberRequired,
                          emailDuplicate: false,
                          phoneDuplicate: _ctx.duplicatePhone(_ctx.phonenumbers[index], index),
                          showError: _ctx.redBorder(_ctx.phonenumbers[index], index, 'PhoneNumber'),
                          phoneCode: _ctx.phoneCodes[index],
                          onValue: ($event: any) => (_ctx.handleInputChange(journey, 'PhoneNumber', $event)),
                          onError: ($event: any) => (_ctx.handleError(journey, 'PhoneNumber', $event))
                        }, null, 8, ["inputValue", "isRequired", "phoneDuplicate", "showError", "phoneCode", "onValue", "onError"])
                      ])
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1))
                ], 4))
              }), 128))
            ])
          ]),
          (_ctx.firstPhoneCode === 1)
            ? (_openBlock(), _createBlock(_component_apply_phone_code_box, {
                key: 0,
                currentCode: _ctx.phoneCodes[_ctx.currentIndex],
                onUpdatePhoneCode: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUpdatePhoneCode($event)))
              }, null, 8, ["currentCode"]))
            : _createCommentVNode("", true),
          (_ctx.showFinalBox)
            ? (_openBlock(), _createBlock(_component_send_updates_box, {
                key: 1,
                numberOfGuests: _ctx.JourneyList.length.toString(),
                onSendUpdates: _cache[4] || (_cache[4] = ($event: any) => (_ctx.SendUpdates($event)))
              }, null, 8, ["numberOfGuests"]))
            : _createCommentVNode("", true),
          (_ctx.showError)
            ? (_openBlock(), _createBlock(_component_toaster, {
                key: 2,
                type: 'error',
                text: _ctx.errorText,
                isMobile: false,
                onUpdateToast: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showError = false))
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMobile == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", {
            style: _normalizeStyle([{ width: _ctx.windowWidth + 'px' }, {"position":"fixed","z-index":"100","top":"0","height":"31px","display":"flex","justify-content":"space-between","align-items":"center","padding":"16px","border-bottom":"2px solid #4aba96","background":"#fafafa"}])
          }, [
            _createElementVNode("img", {
              width: "20",
              height: "20",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goBack())),
              src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/left.svg"
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
              _cache[23] || (_cache[23] = _createElementVNode("h5", null, "Reservation update", -1))
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { style: {"width":"20px","height":"20px"} }, null, -1))
          ], 4),
          _cache[36] || (_cache[36] = _createElementVNode("div", { style: {"display":"flex","margin-top":"64px","justify-content":"center","padding":"32px 24px","flex-direction":"column","gap":"8px"} }, [
            _createElementVNode("h3", null, "Reservation list"),
            _createElementVNode("p", null, "Fill out the information for each reservation, and make your upcoming stay as smooth as possible.")
          ], -1)),
          _createVNode(_component_FloatingBottomBar, {
            headerText: _ctx.isReservationDone() + ' out of ' + _ctx.JourneyList.length + ' updated',
            bodyText: _ctx.isReservationDone() !== _ctx.JourneyList.length ? 'Update the remaining reservations' : 'Confirm & send updates',
            bodyTextRed: _ctx.confirmNotReady && _ctx.isReservationDone() !== _ctx.JourneyList.length,
            active: _ctx.isReservationDone() == _ctx.JourneyList.length,
            isMobile: true,
            onUpdateConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmPressed())),
            onUpdateConfirmNotReady: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmNotReadyPressed()))
          }, null, 8, ["headerText", "bodyText", "bodyTextRed", "active"]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.JourneyList, (journey, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","flex-direction":"column","align-items":"center"},
                key: index
              }, [
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.mobileShowMore[index] == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "reservation-header",
                        onClick: ($event: any) => (_ctx.mobileShowMore[index] = true)
                      }, [
                        _createElementVNode("h1", _hoisted_18, "Reservation " + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.reservationDone(journey))
                            ? (_openBlock(), _createBlock(_component_label_bar, {
                                key: 0,
                                text: 'Filled out',
                                type: 'succes'
                              }))
                            : _createCommentVNode("", true),
                          _cache[25] || (_cache[25] = _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/down.svg" }, null, -1))
                        ])
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  (_ctx.mobileShowMore[index] == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "reservation-header",
                        onClick: ($event: any) => (_ctx.mobileShowMore[index] = false)
                      }, [
                        _createElementVNode("h1", _hoisted_21, "Reservation " + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.reservationDone(journey))
                            ? (_openBlock(), _createBlock(_component_label_bar, {
                                key: 0,
                                text: 'Filled out',
                                type: 'succes'
                              }))
                            : _createCommentVNode("", true),
                          _cache[26] || (_cache[26] = _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/up.svg" }, null, -1))
                        ])
                      ], 8, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.mobileShowMore[index] == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (!_ctx.GroupBookingList[0].HideGuestRoom)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _cache[27] || (_cache[27] = _createElementVNode("img", {
                                  width: "18",
                                  height: "18",
                                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/RoomFeatures/double_bed.svg"
                                }, null, -1)),
                                _createElementVNode("p", null, _toDisplayString(_ctx.findRoomType(journey.RoomType)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.GroupBookingList[0].HideNumberOfGuest)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _cache[28] || (_cache[28] = _createElementVNode("img", {
                                  width: "18",
                                  height: "18",
                                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/person.svg"
                                }, null, -1)),
                                _createElementVNode("p", null, _toDisplayString(journey.NumberOfGuest), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            _cache[29] || (_cache[29] = _createElementVNode("img", {
                              width: "18",
                              height: "18",
                              src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock.svg"
                            }, null, -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(journey.StartDate)), 1),
                            _cache[30] || (_cache[30] = _createElementVNode("img", {
                              width: "14",
                              height: "14",
                              src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/arrow_1_5px/right.png"
                            }, null, -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(journey.EndDate)), 1)
                          ])
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"height":"1px","width":"91%","background":"#dfdfdf","margin-bottom":"24px"} }, null, -1)),
                        _createVNode(_component_input_field_with_message, {
                          label: 'First name',
                          inputValue: journey.FirstName,
                          widthProcent: '91%',
                          isRequired: _ctx.GroupBookingList[0].FirstNameRequired,
                          emailDuplicate: false,
                          showError: _ctx.redBorder(journey.FirstName, index, 'FirstName'),
                          onValue: ($event: any) => (_ctx.handleInputChange(journey, 'FirstName', $event))
                        }, null, 8, ["inputValue", "isRequired", "showError", "onValue"]),
                        _cache[32] || (_cache[32] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1)),
                        _createVNode(_component_input_field_with_message, {
                          label: 'Last name',
                          inputValue: journey.LastName,
                          widthProcent: '91%',
                          isRequired: _ctx.GroupBookingList[0].LastNameRequired,
                          emailDuplicate: false,
                          showError: _ctx.redBorder(journey.LastName, index, 'LastName'),
                          onValue: ($event: any) => (_ctx.handleInputChange(journey, 'LastName', $event))
                        }, null, 8, ["inputValue", "isRequired", "showError", "onValue"]),
                        _cache[33] || (_cache[33] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1)),
                        _createVNode(_component_input_field_with_message, {
                          label: 'Email',
                          inputValue: journey.Email,
                          widthProcent: '91%',
                          isRequired: _ctx.GroupBookingList[0].EmailRequired,
                          emailDuplicate: _ctx.duplicateEmail(journey.Email, index),
                          showError: _ctx.redBorder(journey.Email, index, 'Email'),
                          onValue: ($event: any) => (_ctx.handleInputChange(journey, 'Email', $event)),
                          onError: ($event: any) => (_ctx.handleError(journey, 'Email', $event))
                        }, null, 8, ["inputValue", "isRequired", "emailDuplicate", "showError", "onValue", "onError"]),
                        _cache[34] || (_cache[34] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (_ctx.showCurrentCodePicker(index))
                          }, [
                            _createVNode(_component_country_code_picker, {
                              showError: _ctx.redBorder(_ctx.phoneCodes[index], index, 'PhoneCode'),
                              currentCode: _ctx.phoneCodes[index],
                              country: _ctx.hotelCountry,
                              showAbove: _ctx.GroupBookingList.length <= index + 1 || (_ctx.GroupBookingList.length - 1 <= index + 1 && _ctx.GroupBookingList.length > 2),
                              isMobile: true,
                              onDefaultCode: ($event: any) => (_ctx.onDefaultCode(index, $event)),
                              onUpdateCode: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onUpdateCode($event)))
                            }, null, 8, ["showError", "currentCode", "country", "showAbove", "onDefaultCode"])
                          ], 8, _hoisted_29),
                          _createVNode(_component_input_field_with_message, {
                            label: 'Phone number',
                            inputValue: _ctx.phonenumbers[index],
                            widthProcent: '100%',
                            isRequired: _ctx.GroupBookingList[0].PhoneNumberRequired,
                            emailDuplicate: false,
                            phoneDuplicate: _ctx.duplicatePhone(_ctx.phonenumbers[index], index),
                            showError: _ctx.redBorder(_ctx.phonenumbers[index], index, 'PhoneNumber'),
                            phoneCode: _ctx.phoneCodes[index],
                            onValue: ($event: any) => (_ctx.handleInputChange(journey, 'PhoneNumber', $event)),
                            onError: ($event: any) => (_ctx.handleError(journey, 'PhoneNumber', $event))
                          }, null, 8, ["inputValue", "isRequired", "phoneDuplicate", "showError", "phoneCode", "onValue", "onError"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1))
              ]))
            }), 128))
          ]),
          (_ctx.showCodePicker[_ctx.currentIndex] == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_phone_code_picker, {
                  onUpdateCode: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onUpdateCode($event))),
                  currentCode: _ctx.phoneCodes[_ctx.currentIndex]
                }, null, 8, ["currentCode"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.firstPhoneCode === 1)
            ? (_openBlock(), _createBlock(_component_apply_phone_code_box, {
                key: 1,
                currentCode: _ctx.phoneCodes[_ctx.currentIndex],
                onUpdatePhoneCode: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onUpdatePhoneCode($event)))
              }, null, 8, ["currentCode"]))
            : _createCommentVNode("", true),
          (_ctx.showFinalBox)
            ? (_openBlock(), _createBlock(_component_send_updates_box, {
                key: 2,
                numberOfGuests: _ctx.JourneyList.length.toString(),
                onSendUpdates: _cache[12] || (_cache[12] = ($event: any) => (_ctx.SendUpdates($event)))
              }, null, 8, ["numberOfGuests"]))
            : _createCommentVNode("", true),
          (_ctx.showError)
            ? (_openBlock(), _createBlock(_component_toaster, {
                key: 3,
                type: 'error',
                text: _ctx.errorText,
                isMobile: true,
                onUpdateToast: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showError = false))
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}